var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLamp = function SvgIconLamp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.75 15.25h1.62a1.752 1.752 0 0 0 1.598-2.446l-.001-.004-3.85-8.994-.007-.013a1.76 1.76 0 0 0-1.607-1.043H6.498A1.76 1.76 0 0 0 4.89 3.793l-.006.013-3.852 8.998a1.75 1.75 0 0 0 1.599 2.446H11v4H9a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-2v-4h4.75V18a1 1 0 1 0 2 0zm-16.733-2 3.639-8.5h10.689l3.639 8.5z",
    clipRule: "evenodd"
  })));
};
export default SvgIconLamp;